import { DownloadLink } from "@/components/brand/BrandSection";

export const LogoCard = ({ logo }) => (
  <article className="overflow-hidden rounded-[28px] border border-sky-100 bg-white" data-testid={`brand-logo-${logo.id}`}>
    <div className="flex h-48 items-center justify-center p-8" style={{ background: logo.bg }}>
      <img src={`/brand/aerosoft-${logo.id}.svg`} alt={`Aero Soft Solutions ${logo.name}`} className="max-h-full max-w-full object-contain" />
    </div>
    <div className="border-t border-sky-100 p-5">
      <h3 className="font-display text-lg font-semibold text-ink">{logo.name}</h3>
      <p className="mt-1 text-sm text-slate-600">{logo.use}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <DownloadLink href={`/brand/aerosoft-${logo.id}.svg`} label="SVG (vector)" testid={`brand-logo-${logo.id}-svg`} />
        <DownloadLink href={`/brand/aerosoft-${logo.id}.png`} label={`PNG ${logo.w}×${logo.h}`} testid={`brand-logo-${logo.id}-png`} />
      </div>
    </div>
  </article>
);
